export const MODULE_PADDING_FLAG_KEY = 'hs_enable_module_padding';
export const MODULE_PADDING_CSS_KEY = 'hs_wrapper_css';
export const FIELDS_NOT_EDITABLE_BY_SMART_CONTENT = [MODULE_PADDING_FLAG_KEY, MODULE_PADDING_CSS_KEY];